import {Component, ViewEncapsulation} from '@angular/core';
import {ConfigService, SessionService, User} from '@q9elements/ui-kit/common';

import {getModuleConfigs} from '../../models/navigation';

@Component({
  selector: 'q9sys-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WrapperComponent {
  readonly modules = getModuleConfigs();
  readonly user = this.sessionService.user() as User;

  constructor(private sessionService: SessionService) {}

  goToMainApp() {
    document.location.href = ConfigService.environment.MAIN_APP_URL as string;
  }

  goToProfile() {
    const defaultTeamIndex = this.user.teams.findIndex(team => team.defaultTeam);

    document.location.href = `${ConfigService.environment.MAIN_APP_URL}/t/${defaultTeamIndex}/profile`;
  }
}
